import { IPatient, IPmsPatient } from 'interfaces/patients';
import { convertPhoneNumberToUsByDefault } from 'utils/formatPhoneNumber';

export const getPatientInfoDetail = (
  patient: IPatient,
  pmsPatient: IPmsPatient | null
) => {
  return patient
    ? {
        firstName: patient.firstName || pmsPatient?.firstName || '',
        lastName: patient.lastName || pmsPatient?.lastName || '',
        name: patient.name || pmsPatient?.name || '',
        dob: patient.dob || pmsPatient?.dob || '',
        phoneNumber:
          patient.phoneNumber ||
          convertPhoneNumberToUsByDefault(pmsPatient?.phoneNumber) ||
          '',
        email: patient.email || pmsPatient?.email || '',
        homeAddress: patient.homeAddress,
        postalCode: patient.postalCode,
      }
    : null;
};
